<!-- 文件资料 -->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container recharge-manage">
      <el-form size="small" :inline="true" :model="listQuery" >
        <!-- 文件编号 -->
        <el-form-item :label="$t('ic.fileNo') + ':'">
          <el-input v-model.trim="listQuery.fileNo" style="width:140px;"/>
        </el-form-item>
        <!-- 标题 -->
        <el-form-item :label="$t('icInformation.title') + ':'">
          <el-input v-model.trim="listQuery.fileName" style="width:140px;"/>
        </el-form-item>
        <el-button :loading="btnLoading" size="small" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
      </el-form >
      <el-table
          v-loading="tableLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <el-table-column :label="$t('sysOperationLog.moduleName')" width="60" header-align="center" align="center">
          <template v-slot="{row}">
            <el-button circle size="mini" icon="el-icon-search" :title="$t('button.view')" @click="viewTableBtn(row)" />
          </template>
        </el-table-column>
        <!-- 文件编号 -->
        <el-table-column :label="$t('ic.fileNo')" prop="file_no" align="center"/>
        <!-- 文件名称 -->
        <el-table-column :label="$t('icFile.fileName')" prop="file_name" align="center"/>
        <!-- 文件大小 -->
        <el-table-column :label="$t('icFile.fileSize')" prop="file_size" align="center"/>
        <!-- 创建时间 -->
        <el-table-column :label="$t('Common.createTime')" prop="create_time" align="center"/>
      </el-table>
      <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"

export default {
  name: 'Data',
  components: { Pagination },
  data() {
    return {
      btnLoading: false,
      tableLoading: false,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10
      },
      initDict: {
        status: 'fi_ac_input_status_cn'
      }
    }
  },
  computed: {
    statusList() {
      return this.$ll(this.initDict.status)
    }
  },
  created() {
    // this.getList()
  },
  methods: {
    getList() {
      this.tableLoading = true
      this.btnLoading = true
      // getFiAcInputs({ ...this.listQuery}).then(res => {
      //   this.list = res.data.records
      //   this.total = +res.data.total || 0
      //   this.btnLoading = false
      //   this.tableLoading = false
      // }).catch(err => {
      //   console.warn(err)
      //   this.btnLoading = false
      //   this.tableLoading = false
      // })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    addBtn() {
      this.$router.push({name: 'AccountRecharge'})
    },
    viewTableBtn(row) {
      this.$router.push({ name: 'ViewRecharge', params:{ id: row.id } })
    }
  }
}
</script>

<style scoped>

</style>
